import styled from "styled-components";
import Button from "src/components/shared/Button";

export const ImportTasksPanelWrapper = styled.div<{ fileOverPanel: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: fit-content;

  background-color: ${({ theme, fileOverPanel }) =>
    fileOverPanel
      ? theme.colors.cards.fills.spectator
      : theme.colors.background};
  border: ${({ theme }) =>
    `${theme.border.thinner} dashed ${theme.colors.gray}`};
  border-radius: ${({ theme }) => `${theme.borderRadius.l}`};
`;

export const ImportCSVLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};

  margin-top: 10px;
`;

export const DragAndDropCSVLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.base};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.gray};

  margin-top: 52px;
`;

export const ChooseCSVButton = styled(Button)`
  padding: 8px 16px;
  margin: 5px 0px 77px;
`;
